// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"bdd091cb","166":"a1379df9","182":"c8dedda2","241":"0e0aadba","309":"5073e0d5","370":"19bbfc78","418":"4356c638","419":"ad68e455","982":"5a568847","989":"a462fe3f"}[chunkId] + ".chunk.js";
};